"use strict";
exports.__esModule = true;
exports.equals = void 0;
var equals = function (point1, point2) {
    if (point1 === point2)
        return true;
    return point1.srs === point2.srs && point1.x === point2.x && point1.y === point2.y;
};
exports.equals = equals;
//# sourceMappingURL=equals.js.map